/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Omc } from "@src/app/model/Omc";
import { DateHelper } from "@src/app/shared/dateHelper";
import { FormDateComponent } from "@src/app/shared/form/form-date/form-date.component";

export function getLastRecField() {
    return FormDateComponent.make('Last Rec', 'lastRecDate', {
        readonly: true, formColumn: 4, disable: true, condensed: true,
        toolTip: $localize `
            The date of the last bank reconciliation for the default bank of this OMC.
            The field is color coded, to show green if reconciled in last 30 days.
            Orange if it is 30 to 60 day since reconciliation.
            Red if 60 to 90 days since reconciliation
            Red background if more than 90 days.
            A red block shows default bank was never reconciled.
            `,
        tableStyle: (o: Omc) => {
                const style: Record<string, string> = {};
                if (!o.manageBank) {
                    // Just let it display empty
                } else if (!o.lastRecDate) {
                    style.width = '30px';
                    style.height = '18px';
                    style.borderRadius = '6px';
                    style.backgroundColor = 'red';
                    style.display = 'inline-block';                    
                    //style['background-color'] = 'red'
                } else {
                    const days = DateHelper.daysFromToday(o.lastRecDate)
                    if (days < -90) {
                        style.color = 'white';
                        style.backgroundColor = 'red';
                        style.padding = '2px'
                        style.borderRadius = '3px';
                    } else if (days <= -60) {
                        style.color = 'red'
                    } else if (days <= -30) {
                        style.color = 'orange';
                    } else {
                        style.color = 'green';
                    }
                }
                return style;
            }
    });
}